module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "new-campaign-introduction"
  }, [_c('v-row', {
    staticClass: "mt-2 mb-2",
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('v-img', {
    attrs: {
      "src": require('@/assets/icons/handwave.png'),
      "max-width": "1.5rem",
      "max-height": "1.5rem"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title-text ml-2 mb-0"
  }, [_vm._v(_vm._s(_vm.$t('NewCampaignInitialData.introduction.title')))])], 1), _vm._v(" "), _c('p', {
    staticClass: "body-text text-center mt-2"
  }, [_vm._v(_vm._s(_vm.$t('NewCampaignInitialData.introduction.introductionText')))]), _vm._v(" "), _c('p', {
    staticClass: "section-text text-left pt-4"
  }, [_vm._v(_vm._s(_vm.$t('NewCampaignInitialData.introduction.contractedEquipments')))]), _vm._v(" "), _c('ul', {
    staticClass: "mb-4"
  }, _vm._l((_vm.monitoringProducts), function(product) {
    return _c('li', {
      key: product.id,
      staticClass: "body-text text-left"
    }, [_vm._v(_vm._s(_vm.getProductDetailText(product)))])
  }), 0), _vm._v(" "), _c('v-row', {
    staticClass: "pt-4 mb-2",
    attrs: {
      "justify": "start",
      "align": "center"
    }
  }, [_c('v-img', {
    attrs: {
      "src": require('@/assets/icons/calendar.png'),
      "max-width": "1.5rem",
      "max-height": "1.5rem"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "section-text ml-2 mb-0"
  }, [_vm._v(_vm._s(_vm.$t('NewCampaignInitialData.introduction.thingsToConsiderTitle')))])], 1), _vm._v(" "), _c('p', {
    staticClass: "body-text text-left"
  }, [_vm._v(_vm._s(_vm.$t('NewCampaignInitialData.introduction.thingsToConsiderText')))]), _vm._v(" "), _c('v-row', {
    staticClass: "pt-4 mb-2",
    attrs: {
      "justify": "start",
      "align": "center"
    }
  }, [_c('v-img', {
    attrs: {
      "src": require('@/assets/icons/puzzle.png'),
      "max-width": "1.5rem",
      "max-height": "1.5rem"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "section-text ml-2 mb-0"
  }, [_vm._v(_vm._s(_vm.$t('NewCampaignInitialData.introduction.nextStepsTitle')))])], 1), _vm._v(" "), _c('p', {
    staticClass: "body-text text-left"
  }, [_vm._v(_vm._s(_vm.$t('NewCampaignInitialData.introduction.nextStepsText')))]), _vm._v(" "), _c('ul', _vm._l((_vm.$t('NewCampaignInitialData.introduction.nextStepsTextItems')), function(item) {
    return _c('li', {
      key: item,
      staticClass: "body-text text-left"
    }, [_vm._v(_vm._s(item))])
  }), 0), _vm._v(" "), _c('v-row', {
    staticClass: "mt-2",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": _vm.$t('NewCampaignInitialData.introduction.campaignNameInput.placeholder'),
      "hint": _vm.$t('NewCampaignInitialData.introduction.campaignNameInput.hint'),
      "outlined": "",
      "background-color": "white",
      "persistent-hint": "",
      "flat": "",
      "rules": [_vm.rules.fieldRequired],
      "validate-on-blur": "",
      "required": ""
    },
    model: {
      value: (_vm.campaignName),
      callback: function($$v) {
        _vm.campaignName = $$v
      },
      expression: "campaignName"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "action-row"
  }, [_c('v-row', {
    staticClass: "mt-2",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-btn', {
    staticClass: "submit-button",
    attrs: {
      "color": "#0098E1",
      "disabled": !_vm.campaignName,
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.startCampaign()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('NewCampaignInitialData.introduction.startCampaign')))])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-519e62e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Campaigns/NewCampaignIntroduction.vue
// module id = 1724
// module chunks = 0